module.exports = __webpack_public_path__ + "img/anvil.e5bc8cb4.svg";